import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-contact-profiles-icon',
  templateUrl: './contact-profiles-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ContactProfilesIconComponent {
  localizationScope = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;

  @Input() iconClass: string = 'ms-1 align-bottom';
  @Input() iconSizeClass: string = 'f-i-sm';
  @Input() container: string = 'target';
  @Input() crmId: number | null | undefined;
  @Input() prId: number | null | undefined;
  @Input() isPrimaryContact?: boolean;

  get isBdOnly() {
    return !this.crmId && this.prId;
  }

  getIconClass() {
    if (this.isPrimaryContact) {
      return this.crmId ? (this.prId ? 'f-i-mixed-primary text-primary-600' : 'f-i-crm-primary text-primary-600') : '';
    }
    return this.crmId ? (this.prId ? 'f-i-mixed-non-primary text-muted' : 'f-i-crm text-muted') : '';
  }

  getIconTitle() {
    if (this.crmId) {
      if (this.prId) {
        if (this.isPrimaryContact) {
          return 'primaryContactBdCrmIconTitle';
        } else {
          return 'contactBdCrmIconTitle';
        }
      } else {
        if (this.isPrimaryContact) {
          return 'primaryContactCrmOnlyIconTitle';
        } else {
          return 'contactCrmOnlyIconTitle';
        }
      }
    }
    return null;
  }
}
